<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CompaniesCard from 'dashboard/components-next/Companies/CompaniesCard/CompaniesCard.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['create']);

const onClick = () => {
  emit('create');
};

// Sample data for empty state preview
const sampleCompanies = [
  {
    id: 1,
    name: 'Acme Corporation',
    domain: 'acme.com',
    description: 'Global technology solutions provider',
    contactsCount: 12,
    avatarUrl: null,
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    name: 'TechStart Inc.',
    domain: 'techstart.io',
    description: 'Innovative startup company',
    contactsCount: 5,
    avatarUrl: null,
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 3,
    name: 'Global Services Ltd.',
    domain: 'globalservices.com',
    description: 'Enterprise consulting services',
    contactsCount: 24,
    avatarUrl: null,
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <CompaniesCard
          v-for="company in sampleCompanies"
          :id="company.id"
          :key="company.id"
          :name="company.name"
          :domain="company.domain"
          :description="company.description"
          :contacts-count="company.contactsCount"
          :avatar-url="company.avatarUrl"
          :updated-at="company.updatedAt"
        />
      </div>
    </template>
    <template #actions>
      <div v-if="showButton">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
      </div>
    </template>
  </EmptyStateLayout>
</template>
